import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { GitMerge, Loader2, Split } from 'lucide-react';
import { getApiHeaders } from '../../utils/apiHelpers';
import { API_ARCHIVIO } from './archivioApi';

const BTN = 'inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold transition-colors active:scale-95 disabled:opacity-60';

const Proposta = ({ p, indice, onFatto }) => {
  const [invio, setInvio] = useState(null);
  const decidi = async (decisione) => {
    setInvio(decisione);
    try {
      await axios.post(`${API_ARCHIVIO}/fornitori/decisione`, { chiavi: p.chiavi, decisione }, { headers: getApiHeaders() });
      toast.success(decisione === 'unisci' ? 'Fornitori uniti in una sola cartella' : 'Tenuti separati');
      onFatto();
    } catch (e) {
      toast.error('Operazione non riuscita, riprova');
      setInvio(null);
    }
  };
  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-2 px-4 py-3" data-testid={`archivio-doppione-${indice}`}>
      <p className="min-w-0 basis-full sm:basis-auto sm:flex-1 text-sm text-white lg:text-gray-900 break-words">
        <span className="font-semibold">{p.a.nome}</span>
        <span className="text-slate-400 lg:text-gray-500"> ({p.a.n_ddt} DDT)</span>
        <span className="mx-2 text-amber-300 lg:text-amber-600">⇄</span>
        <span className="font-semibold">{p.b.nome}</span>
        <span className="text-slate-400 lg:text-gray-500"> ({p.b.n_ddt} DDT)</span>
      </p>
      <div className="flex items-center gap-2">
        <button type="button" onClick={() => decidi('unisci')} disabled={!!invio} data-testid={`archivio-doppione-unisci-${indice}`}
          className={`${BTN} bg-purple-600 text-white hover:bg-purple-700`}>
          {invio === 'unisci' ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <GitMerge className="h-3.5 w-3.5" />} Unisci
        </button>
        <button type="button" onClick={() => decidi('separati')} disabled={!!invio} data-testid={`archivio-doppione-separa-${indice}`}
          className={`${BTN} bg-white/10 text-slate-200 hover:bg-white/20 lg:bg-gray-100 lg:text-gray-700 lg:hover:bg-gray-200`}>
          {invio === 'separati' ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Split className="h-3.5 w-3.5" />} Tieni separati
        </button>
      </div>
    </div>
  );
};

export const ProposteDoppioni = ({ proposte, onFatto }) => {
  if (!proposte?.length) return null;
  return (
    <div className="rounded-2xl border border-amber-500/30 bg-amber-500/5 lg:bg-amber-50/60 lg:border-amber-200 overflow-hidden" data-testid="archivio-doppioni">
      <div className="px-4 pt-3 pb-2">
        <p className="text-sm font-semibold text-amber-200 lg:text-amber-800" data-testid="archivio-doppioni-titolo">
          Forse è lo stesso fornitore ({proposte.length})
        </p>
        <p className="text-xs text-amber-200/70 lg:text-amber-700/80">Unisci le cartelle se è lo stesso fornitore: cambia solo l'Archivio, i DDT restano come sono.</p>
      </div>
      <div className="divide-y divide-amber-500/20 lg:divide-amber-100 border-t border-amber-500/20 lg:border-amber-100">
        {proposte.map((p, i) => <Proposta key={p.chiavi.join('|')} p={p} indice={i} onFatto={onFatto} />)}
      </div>
    </div>
  );
};
